export default __webpack_public_path__ + "locales/pt-BR/JavascriptSdk.json?hash=cfef77189317d07952246ebb1a4a6b6d";